module.exports = __webpack_public_path__ + "static/media/olenna.b63726a9.jpg";